import React, { Component } from 'react';
import WebpackerReact from 'webpacker-react';
import FormCreate from '../components/settings/Positions/FormCreate'

class FormCreatePosition extends Component {
    render() {
        return (
            <FormCreate 
                usuario={this.props.current_user} 
                estados={this.props.estados} 
                editMode={this.props.editMode} 
                position={this.props.position}
                procesos={this.props.procesos}
                tenant={this.props.tenant}
                section_accions={this.props.section_accions}

                format_categories={this.props.format_categories}
                formats_permissions_all={this.props.formats_permissions_all}
                position_format_categories_all={this.props.position_format_categories_all}
                permissions={this.props.permissions}
                section_custom_views={this.props.section_custom_views}
                custom_view_permissions={this.props.custom_view_permissions}
            />
        );
    }
}

export default FormCreatePosition;
WebpackerReact.setup({ FormCreatePosition });